import { createActions, createReducer } from 'reduxsauce'

import ConsultaDespesasCartaoCorporativoService from '../../servicos/ConsultaDespesasCartaoCorporativoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaDespesasCartaoCorporativoInicio: [],
    buscaConsultaDespesasCartaoCorporativoErro: ['erro'],
    buscaConsultaDespesasCartaoCorporativoSucesso: ['consultaDespesasCartaoCorporativo'],
    limpar: [],
    setConsultaDespesasCartaoCorporativoEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaDespesasCartaoCorporativo = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaDespesasCartaoCorporativoInicio())
        let serv = new ConsultaDespesasCartaoCorporativoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaDespesasCartaoCorporativoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaDespesasCartaoCorporativoErro(error)))
    }
}

const buscaConsultaDespesasCartaoCorporativoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaDespesasCartaoCorporativoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaDespesasCartaoCorporativoSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaDespesasCartaoCorporativo.resultado,
        dataSincronizacaoDados: action.consultaDespesasCartaoCorporativo.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaDespesasCartaoCorporativoEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_DESPESAS_CARTAO_CORPORATIVO_INICIO]: buscaConsultaDespesasCartaoCorporativoInicio,
    [Types.BUSCA_CONSULTA_DESPESAS_CARTAO_CORPORATIVO_ERRO]: buscaConsultaDespesasCartaoCorporativoErro,
    [Types.BUSCA_CONSULTA_DESPESAS_CARTAO_CORPORATIVO_SUCESSO]: buscaConsultaDespesasCartaoCorporativoSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_DESPESAS_CARTAO_CORPORATIVO_ESTADO_DT]: setConsultaDespesasCartaoCorporativoEstadoDT,
})
